export default function scrollRecognition() {
  console.log("scroll loaded");
  window.isScrolled = false;
  let navbar = document.querySelector("#wrapper > header");
  window.addEventListener("scroll", (x) => {
    // console.log(window.scrollY);
    if (window.scrollY >= 100 && !window.isScrolled) {
      document.body.classList.add("scrolled");
      window.isScrolled = true;
    } else {
      if (window.scrollY < 100) {
        document.body.classList.remove("scrolled");
        window.isScrolled = false;
      }
    }
  });
}
